import React from 'react';

interface MaintenanceTabPanelHeaderProps {
    children: React.ReactNode;
}

export function MaintenanceTabPanelHeader({
    children,
}: MaintenanceTabPanelHeaderProps) {
    return (
        <div className="sticky top-24 z-20 -mx-4 -mt-4 mb-4 bg-white px-4 pt-4 pb-4 border-b border-gray-100">
            {children}
        </div>
    );
}
